import { t } from '@lingui/macro'
import { Statement } from '@/services/tigerx'

export const getTigerXHistoryKeysTranslations = (): Partial<Record<keyof Statement, string>> => {
  return {
    createAt: t({
      id: 'exchangeHistoryTigerXKeys.createAt',
      comment: 'createAt',
    }),
    businessType: t({
      id: 'exchangeHistoryTigerXKeys.businessType',
      comment: 'businessType',
    }),
    exchangeType: t({
      id: 'exchangeHistoryTigerXKeys.exchangeType',
      comment: 'exchangeType',
    }),
    tradingFeeCoin: t({
      id: 'exchangeHistoryTigerXKeys.tradingFeeCoin',
      comment: 'tradingFeeCoin',
    }),
    sym: t({
      id: 'exchangeHistoryTigerXKeys.sym',
      comment: 'sym',
    }),
    rpnl: t({
      id: 'exchangeHistoryTigerXKeys.rpnl',
      comment: 'rpnl',
    }),
    side: t({
      id: 'exchangeHistoryTigerXKeys.side',
      comment: 'side',
    }),
  }
}

export const getTigerXHistoryKeysModalTranslations = (): Partial<Record<keyof Statement, string>> => {
  return {
    createAt: t({
      id: 'exchangeHistoryTigerXKeys.createAt',
      comment: 'createAt',
    }),
    side: t({
      id: 'exchangeHistoryTigerXKeys.side',
      comment: 'side',
    }),
    quantity: t({
      id: 'exchangeHistoryTigerXKeys.quantity',
      comment: 'quantity',
    }),
    price: t({
      id: 'exchangeHistoryTigerXKeys.price',
      comment: 'price',
    }),
    tradingFee: t({
      id: 'exchangeHistoryTigerXKeys.tradingFee',
      comment: 'tradingFee',
    }),
    tradingFeeCoin: t({
      id: 'exchangeHistoryTigerXKeys.tradingFeeCoin',
      comment: 'tradingFeeCoin',
    }),
    execType: t({
      id: 'exchangeHistoryTigerXKeys.execType',
      comment: 'execType',
    }),
    rpnl: t({
      id: 'exchangeHistoryTigerXKeys.rpnl',
      comment: 'rpnl',
    }),
  }
}

export type TranslationHintHistoryTigerX = Extract<keyof Statement, 'beforeAvailable' | 'afterAvailable'>

export const getTigerXHistoryKeysTranslationsHint = (key: TranslationHintHistoryTigerX) => {
  const translations = {
    beforeAvailable: t({
      id: 'exchangeHistoryTigerXKeys.beforeAvailable.hint',
      comment: 'beforeAvailable',
    }),
    afterAvailable: t({
      id: 'exchangeHistoryTigerXKeys.afterAvailable.hint',
      comment: 'afterAvailable',
    }),
  }

  return translations[key]
}
